import format from "date-fns/format";
import locale from "date-fns/locale/en-GB";

const options = { locale };

export const dayOfMonthWithSuffix = (date: number | Date) => format(date, "do", options);
export const longDate = (date: number | Date) => format(date, "PPP", options);
export const longDateTime = (date: number | Date) => format(date, "PPPp", options);
export const shortDate = (date: number | Date) => format(date, "P", options);
